import { call, put, takeLatest } from "redux-saga/effects"
import axios from "axios"
import { updateSwitchUser } from "services/control-panel"
import {
  GET_USERS_WATCHER,
  DELETE_USER_WATCHER,
  SWITCH_USER_WATCHER,
  UPDATE_INFO_USER,
} from "./constants"
import {
  getUsersWatcher,
  getUsersSuccess,
  getUsersFailed,
  deleteUserFailed,
} from "./actions"
import { getUserWatcher } from "../../UserHeaderBox/actions"
import { LOCAL_COMPANY_ID } from "../../../utils/storage"

export function* getUsersSaga() {
  try {
    const { data } = yield call(fetchGlobalApi, {
      method: "GET",
      endpoint: `companies/${LOCAL_COMPANY_ID()}/users`,
    })

    yield put(getUsersSuccess(data.data))
  } catch (error) {
    yield put(getUsersFailed())
    returnMessage(error)
  }
}

// DELETE USER
export function* deleteUserSaga(action) {
  try {
    const data = yield call(fetchGlobalApi, {
      method: "DELETE",
      endpoint: `companies/${LOCAL_COMPANY_ID()}/users/${action.payload}`,
    })

    yield put(getUsersWatcher())
    returnMessage(data)
  } catch (error) {
    yield put(deleteUserFailed())
    returnMessage(error)
  }
}

export function* switchUserSaga(action) {
  try {
    const data = yield call(updateSwitchUser, action.payload)

    yield put(getUsersWatcher())
  } catch (error) {
    yield put(getUsersWatcher())
    returnMessage(error)
  }
}

export function* updateInfoUserSaga(action) {
  yield put(getUserWatcher())
}

// Individual exports for testing
export default function* userManagementSaga() {
  yield takeLatest(GET_USERS_WATCHER, getUsersSaga)
  yield takeLatest(DELETE_USER_WATCHER, deleteUserSaga)
  yield takeLatest(SWITCH_USER_WATCHER, switchUserSaga)
  yield takeLatest(UPDATE_INFO_USER, updateInfoUserSaga)
}
